module.exports = __webpack_public_path__ + "static/media/ipff.c2de4841.jpeg";